// extracted by mini-css-extract-plugin
module.exports = {"modal":"Share_modal__pq_5q"};